import { getImagePath } from '../../common/productImageUtils';
let cancelToken;
export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export function getProductInventoryApi(params = {}) {
  return new Promise(async (res, rej) => {
    try {
      const { default: axios } = await import('axios');
      const { data } = await axios.get('/marketplace/static/php/web/b2bWebsite.php', { params });
      if (data.status) {
        const currentPage = params.pageNo || 1;
        const result = {
          currentPage,
          products: data.data?.productData || [],
          totalCount: data.data?.totalCount,
          lastPage: data.data?.lastPage
        }
        return res(result);
      }
      return rej(data);
    } catch (err) {
      return rej(err);
    }
  })
}

export function getProductInventoryApiforSearch(params = {}) {
  return new Promise(async (res, rej) => {
    try {
      if (typeof cancelToken != typeof undefined) {
        cancelToken.cancel("Operation canceled due to new request.")
      }
      const { default: axios } = await import('axios');
      cancelToken = axios.CancelToken.source();
      const { data } = await axios.get('/marketplace/static/php/web/b2bWebsite.php', {
        params, cancelToken: cancelToken.token
      });
      if (data.status) {
        const currentPage = params.pageNo || 1;
        const result = {
          currentPage,
          products: data.data?.productData || [],
          totalCount: data.data?.totalCount
        }
        return res(result);
      }
      return rej(data);
    } catch (err) {
      return rej(err);
    }
  })
}

export const getInventoryImagePath = (url,isTemplate) => {
  let finalUrl = getImagePath(url,isTemplate)
  return finalUrl;
}

export const setCookie = (name, value) => {
  var date = new Date();
  date.setTime(date.getTime() + (24 * 60 * 60 * 365));
  document.cookie = name + '=' + value + '; path=/; expires=' + date.toUTCString();
}

export const getCookie = (name) => {
  if (!document.cookie.includes(name)) {
    return '';
  }
  let temp = document.cookie.split(name + '=')[1];
  return temp.split(';')[0]
}
